import { render, staticRenderFns } from "./RoomConsult.vue?vue&type=template&id=425f3158"
import script from "./RoomConsult.vue?vue&type=script&lang=js"
export * from "./RoomConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports